import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import planningApi from "../api/planningApi";

export const fetchEvenementsPublic = createAsyncThunk(
  "agenda/fetchEvenementsPublic",
  async (params = {}, { rejectWithValue }) => {
    try {
      return await planningApi.getEvenementsPublic(params);
    } catch (err) {
      return rejectWithValue(err.response?.data ?? err.message);
    }
  }
);

export const fetchEvenementPublicDetail = createAsyncThunk(
  "agenda/fetchEvenementPublicDetail",
  async (id, { rejectWithValue }) => {
    try {
      return await planningApi.getEvenementPublicDetail(id);
    } catch (err) {
      return rejectWithValue(err.response?.data ?? err.message);
    }
  }
);

const agendaSlice = createSlice({
  name: "agenda",
  initialState: {
    evenements: [],
    evenementDetail: null,
    loading: false,
    loadingDetail: false,
    error: null,
  },
  reducers: {
    clearEvenementDetail(state) {
      state.evenementDetail = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEvenementsPublic.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEvenementsPublic.fulfilled, (state, action) => {
        state.loading = false;
        state.evenements = Array.isArray(action.payload)
          ? action.payload
          : action.payload?.results ?? [];
      })
      .addCase(fetchEvenementsPublic.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? "Erreur lors du chargement des événements";
      })

      .addCase(fetchEvenementPublicDetail.pending, (state) => {
        state.loadingDetail = true;
        state.error = null;
      })
      .addCase(fetchEvenementPublicDetail.fulfilled, (state, action) => {
        state.loadingDetail = false;
        state.evenementDetail = action.payload;
      })
      .addCase(fetchEvenementPublicDetail.rejected, (state, action) => {
        state.loadingDetail = false;
        state.error = action.payload ?? "Événement introuvable";
      });
  },
});

export const { clearEvenementDetail } = agendaSlice.actions;
export default agendaSlice;
